import { render, staticRenderFns } from "./AperProfil.vue?vue&type=template&id=644449cd&"
import script from "./AperProfil.vue?vue&type=script&lang=ts&"
export * from "./AperProfil.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports